import React, { useContext, useEffect, useState } from "react";
import { AiFillStar } from "react-icons/ai";
// import { BsTrash } from 'react-icons/bs';
// import { FaMapMarkerAlt } from 'react-icons/fa';
import { FiEdit3 } from "react-icons/fi";
import { GoPrimitiveDot } from "react-icons/go";
import { context } from "../FrontPanel/FrontPanel";
import Footer from "../Shared/Footer/Footer";
import Navbar from "../Shared/Navbar/Navbar";
import card from "../../images/card.png";
// import cash from "../../images/cash.png";
import cash from "../../images/tk_icon.png";
import bkash from "../../images/bkash.png";
import nagad from "../../images/nagad.png";
import rocket from "../../images/rocket.png";
import upay from "../../images/upay.jpg";
import thanks from "../../images/thanks.png";
import Modal from "react-modal";
import { HiOutlineX } from "react-icons/hi";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const Checkout = () => {
  const {
    pharmacyData,
    cart,
    setCart,
    userData,
    pharmacyDataDetails,
    vatTaxDelivery,
  } = useContext(context);

  const [address, setAddress] = useState();
  useEffect(() => {
    setAddress(JSON.parse(localStorage.getItem("address")));
  }, []);

  // console.log("cart", pharmacyData)
  const subTotal = cart.reduce(
    (totalPrice, item) =>
      totalPrice + parseFloat(item.price) * parseFloat(item.qty),
    0
  );

  const per = (parseFloat(vatTaxDelivery.vat) / 100) * parseFloat(subTotal);
  const total = subTotal + per + vatTaxDelivery.delivery_charge;

  const [modalIsOpen, setIsOpen] = useState(false);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "5px",
      width: "40%",
    },
  };
  // check prescription
  const [prescriptionFile, setPrescriptionFile] = useState("");
  const [prescribed, setPrescribed] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    order_no: "",
    total_price: "",
    discount: "",
    total_pirce_after_discount: "",
    name: "",
    email: "",
    phone: "",
    payment_method: "",
    user_id: "",
    seller_id: "2",
  });

  useEffect(() => {
    cart.map((item) => {
      if (item.category === "Prescription") {
        setPrescribed(true);
      }
    });
    setOrderDetails({
      ...orderDetails,
      name: userData?.user?.name,
      email: userData?.user?.email,
      phone: userData?.user?.phone_number,
      user_id: userData?.user?.id,
      address: address?.formatted_address,
    });
  }, [cart, userData]);
  const handlePrescriptionFile = (e) => {
    setPrescriptionFile(e.target.files[0]);
  };

  const navigate = useNavigate();
  const param = useParams();
  const [loading, setLodaing] = useState(false);
  console.log(address, "orderDetails");
  const placeOrder = () => {
    setLodaing(true);
    if (address?.formatted_address && orderDetails.payment_method) {
      const order = new FormData();
      order.append("total_price", subTotal);
      order.append("discount", 0);
      order.append("total_pirce_after_discount", subTotal);
      order.append("name", orderDetails.name);
      order.append("email", orderDetails.email);
      order.append("phone", orderDetails.phone);
      order.append("address", address?.formatted_address);
      order.append("payment_method", orderDetails.payment_method);
      order.append("user_id", orderDetails.user_id);
      order.append("seller_id", param.id);
      order.append("prescription", prescriptionFile);
      order.append("status_id", "Pending");
      axios.post(`orders`, order).then((res) => {
        console.log("data", res.data);
        if (res.status === 200) {
          cart.map((item) => {
            const data = new FormData();
            data.append("order_id", res.data.order.id);
            data.append("order_no", res.data.order.order_no);
            data.append("product_id", item.id);
            data.append("qty", item.qty);
            data.append("product_name", item.name);
            data.append("price", item.price);
            data.append("discount", 0);
            data.append(
              "total_price",
              (parseFloat(item.price) * parseInt(item.qty)).toFixed(2)
            );
            data.append(
              "total_pirce_after_discount",
              (parseFloat(item.price) * parseInt(item.qty)).toFixed(2)
            );
            data.append("name", orderDetails.name);
            data.append("user_id", orderDetails.user_id);
            data.append("seller_id", param.id);

            data.append(
              "prescription",
              item.prescription === undefined ? "" : item.prescription
            );

            axios.post(`save-orders-details`, data).then((res) => {
              console.log(res);
            });
          });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Order Placed Successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          navigate(`/profile/${userData?.user?.id}`);
          setCart([]);
          setLodaing(false);
        }
      });
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Validation Error",
        // text: 'Please Select Address and Payment Method',
        text: !orderDetails.address
          ? "Please Set Address"
          : !orderDetails.payment_method && "Please Set Payment Method",
        showConfirmButton: false,
        timer: 1500,
      });
      setLodaing(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="ml-2 sm:ml-6 md:ml-12 lg:ml-20 xl-ml-28">
        <div className="pharmacy-detail py-4">
          <h2 className="text-[#134E47] font-bold lg:text-[18px]">
            {pharmacyDataDetails?.store_name}
          </h2>
          <p className="text-[#134E47]">
            <AiFillStar className="inline " />
            <span className="text-[13px] font-semibold">4.5</span>
            <span className="text-xs">(120)</span>
          </p>
          <ul className="text-[#134E47] list-disc">
            <li className="inline-block text-xs">
              <GoPrimitiveDot className="inline" />
              All Pharmacy
            </li>
            <li className="inline-block text-xs">
              <GoPrimitiveDot className="inline" />
              Pharmacy
            </li>
            <li className="inline-block ml-2 text-xs">
              <GoPrimitiveDot className="inline" /> Medicines
            </li>
            <li className="inline-block ml-2 text-xs">
              <GoPrimitiveDot className="inline" /> Checkout
            </li>
          </ul>
        </div>
      </div>
      <hr className="border" />
      <div className="md:grid grid-cols-12 mx-4 sm:mx-10 md:mx-26 lg:mx-36 xl:mx-56 mt-6">
        <div className="col-span-8">
          <div className="delivery-details custom-shadow p-3">
            <div className="md:grid grid-cols-2">
              <h6 className="text-[#134E47] font-bold">
                <span className="bg-[#134E47] text-white text-sm py-1 px-2 rounded-md mr-4">
                  1
                </span>
                Delivery details
              </h6>
              {prescribed && (
                <h6 className="text-red-500 text-sm font-bold">
                  Prescription must be uploaded for prescription medicine !!
                </h6>
              )}
            </div>

            {/* <div className="grid grid-cols-2 mt-2">
                            <div className="">
                                <label className='text-[#134E47] text-sm mb-1'>Delivery Time: </label>
                                <select className='border rounded text-sm w-full py-1 focus:border focus:outline-none px-2 text-[#134E47] font-semibold'>
                                    <option className='bg-red'>Sun, Jul 17</option>
                                </select>
                            </div>
                            <div className="mt-6">
                                <select className='border rounded text-sm w-full py-1 focus:border focus:outline-none px-2 text-[#134E47] font-semibold'>
                                    <option className='bg-red'>ASAP</option>
                                </select>
                            </div>
                        </div> */}
            <div className="flex justify-between mt-2">
              <h6 className="text-[#134E47] text-sm font-semibold">
                Delivery Address:
              </h6>
              {/* <h6 className="text-[#134E47] text-sm font-semibold">+ Add Address:</h6> */}
            </div>
            <div className="p-2 delivery-address">
              <div className="grid grid-cols-12">
                {/* <div className="col-span-9">
                                    <FaMapMarkerAlt className='inline' />
                                    <p className='text-[#727272] inline ml-3'>3 Dhakeshwari Rd Dhaka</p>
                                    <p className='text-[#727272] ml-7'>Note to rider: none</p>
                                    <textarea className='rounded border border-gray-300 w-full' cols="30" rows="10"></textarea>
                                </div>
                                <div className="col-span-3">
                                    <BsTrash className='cursor-pointer float-right inline rounded mt-1 text-[15px] text-[#BC0000] mr-1' />
                                    <FiEdit3 className='cursor-pointer float-right inline rounded mt-1 text-[15px] text-[#134E47] mr-3' />
                                </div> */}
                <div className="col-span-12">
                  <textarea
                    className="rounded border p-2 border-gray-300 w-full"
                    value={address?.formatted_address}
                    onChange={(e) => {
                      setAddress({
                        formatted_address: e.target.value,
                      });
                      // setOrderDetails({
                      //   ...orderDetails,
                      //   address: e.target.value,
                      // });
                    }}
                    placeholder="Address"
                    cols="30"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="personal-details custom-shadow p-3 mt-2">
            <div className="flex justify-between mb-2">
              <h6 className="text-[#134E47] font-bold">
                <span className="bg-[#134E47] text-white text-sm py-1 px-2 rounded-md mr-4">
                  2
                </span>
                Personal details
              </h6>
              <FiEdit3 className="cursor-pointer float-right inline rounded mt-1 text-[15px] text-[#134E47] mr-3" />
            </div>
            {/* <p className='text-[#727272] text-sm ml-7'>Name: <span className="font-bold">Omar Culhane</span></p>
                        <p className='text-[#727272] text-sm ml-7'>Email: <span className="font-bold">omarculhane@gmail.com</span></p>
                        <p className='text-[#727272] text-sm ml-7'>Phone: <span className="font-bold">+880 12345678</span></p> */}
            <div className="grid grid-cols-12 mb-1">
              <div className="col-span-2">
                <p className="text-[#727272] text-sm ml-7">Name: </p>
              </div>
              <div className="col-span-9">
                <input
                  value={orderDetails.name}
                  className="font-bold text-sm w-full px-4 py-1 border border-solid border-gray-300 rounded"
                  type="text"
                  placeholder="Name"
                />
              </div>
            </div>
            <div className="grid grid-cols-12 mb-1">
              <div className="col-span-2">
                <p className="text-[#727272] text-sm ml-7">Email: </p>
              </div>
              <div className="col-span-9">
                <input
                  value={orderDetails.email}
                  className="font-bold text-sm w-full px-4 py-1 border border-solid border-gray-300 rounded"
                  type="text"
                  placeholder="Name"
                />
              </div>
            </div>
            <div className="grid grid-cols-12 mb-1">
              <div className="col-span-2">
                <p className="text-[#727272] text-sm ml-7">Phone: </p>
              </div>
              <div className="col-span-9">
                <input
                  value={orderDetails.phone}
                  className="font-bold text-sm w-full px-4 py-1 border border-solid border-gray-300 rounded"
                  type="text"
                  placeholder="Phone Number"
                />
              </div>
            </div>
          </div>
          <div className="personal-details custom-shadow p-3 mt-2">
            <h6 className="text-[#134E47] font-bold">
              <span className="bg-[#134E47] text-white text-sm py-1 px-2 rounded-md mr-4">
                3
              </span>
              Payment
            </h6>
            <div className="mt-2 border rounded p-2 d-flex">
              <input
                onChange={(e) =>
                  setOrderDetails({
                    ...orderDetails,
                    payment_method: e.target.value,
                  })
                }
                value="Cradit / Dabit Card"
                type="radio"
                className="accent-[#134E47] mr-3 mt-1"
                name="pay"
                id=""
              />
              <label className="text-sm">Cradit / Dabit Card</label>
              <img src={card} alt="" className="float-right" />
            </div>
            <div className="mt-2 border rounded p-2 d-flex">
              <input
                onChange={(e) =>
                  setOrderDetails({
                    ...orderDetails,
                    payment_method: e.target.value,
                  })
                }
                value="Cash"
                type="radio"
                className="accent-[#134E47] mr-3 mt-1"
                name="pay"
                id=""
              />
              <label className="text-sm">Cash</label>
              <img
                width={"15px"}
                height={"15px"}
                src={cash}
                alt=""
                className="float-right mr-1"
              />
              <div className="d">
                <h6 className="font-semibold text-sm mt-2">PAY BY CASH</h6>
                <p className="text-xs text-[#393939]">
                  Consider payment upon ordering for contactless delivery. You
                  can't pay by a card to the rider upon delivery.
                </p>
              </div>
            </div>
            <div className="mt-2  grid  xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2">
              <div className="flex items-center p-2 border rounded">
                <input
                  onChange={(e) =>
                    setOrderDetails({
                      ...orderDetails,
                      payment_method: e.target.value,
                    })
                  }
                  value="Bkash"
                  type="radio"
                  className="accent-[#134E47] mr-3 mt-1"
                  name="pay"
                  id=""
                />
                <img src={bkash} alt="" className=" h-[35px]" />
              </div>
              <div className="flex items-center p-2 border rounded">
                <input
                  onChange={(e) =>
                    setOrderDetails({
                      ...orderDetails,
                      payment_method: e.target.value,
                    })
                  }
                  value="Nagad"
                  type="radio"
                  className="accent-[#134E47] mr-3 mt-1"
                  name="pay"
                  id=""
                />
                <img src={nagad} alt="" className=" h-[35px]" />
              </div>
              <div className="flex items-center p-2 border rounded">
                <input
                  onChange={(e) =>
                    setOrderDetails({
                      ...orderDetails,
                      payment_method: e.target.value,
                    })
                  }
                  value="Rocket"
                  type="radio"
                  className="accent-[#134E47] mr-3 mt-1"
                  name="pay"
                  id=""
                />
                <img src={rocket} alt="" className=" h-[35px]" />
              </div>
              <div className="flex items-center p-2 border rounded">
                <input
                  onChange={(e) =>
                    setOrderDetails({
                      ...orderDetails,
                      payment_method: e.target.value,
                    })
                  }
                  value="Upay"
                  type="radio"
                  className="accent-[#134E47] mr-3 mt-1"
                  name="pay"
                  id=""
                />
                <img src={upay} alt="" className=" h-[35px]" />
              </div>
            </div>
            <div className="prescription mt-2 border rounded p-2">
              <label>
                Please upload your prescription
                {prescribed && (
                  <span className="text-red-500 font-bold">*</span>
                )}
              </label>
              <input
                type="file"
                onChange={handlePrescriptionFile}
                name=""
                id=""
                className="w-full mt-1"
              />
            </div>
            <div className="d mt-2">
              <h6 className="text-[#134E47] text-sm font-bold mb-2">
                Do you have a voucher ?
              </h6>
              <p>
                By making this purchase you agree to our
                <a className="text-[#134E47] text-sm font-bold mb-2" href="#">
                  terms and conditions
                </a>
                .
              </p>

              <button
                disabled={loading}
                onClick={() => {
                  if (cart.length > 0) {
                    placeOrder();
                  } else {
                    Swal.fire({
                      position: "center",
                      icon: "warnnig",
                      title: "Your cart is empty!",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    navigate("/pharmacy-list");
                  }
                }}
                className=" w-full mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg"
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
        <div className="col-span-4 p-2">
          <div className="text-center py-5">
            <h6 className="font-bold">
              Your order from {pharmacyDataDetails?.store_name} -{" "}
              {address?.formatted_address}
            </h6>
          </div>
          <div className="cart-items">
            {cart.length > 0 &&
              cart.map((item, i) => (
                <div key={i} className="grid grid-cols-12 mb-1">
                  <div className="col-span-9">
                    <p className="text-[#134E47] font-semibold text-sm">
                      {item.qty} X {item.name || item.macrohealth_sg}
                    </p>
                  </div>
                  <div className="col-span-3 text-right">
                    <p className="text-[#8C8C8C] font-semibold text-sm">
                      {(parseFloat(item.price) * parseFloat(item.qty)).toFixed(
                        2
                      )}
                    </p>
                  </div>
                  {/* <div className="col-span-1 flex justify-end">
                            <HiOutlineX onClick={() => removeProduct(item)} className='hover:text-[red] inline cursor-pointer' />
                        </div> */}
                </div>
              ))}

            <hr className="border" />
            <div className="grid grid-cols-12">
              <div className="col-span-9">
                <p className="text-[#8C8C8C] text-sm">Subtotal</p>
              </div>
              <div className="col-span-3 text-right">
                <p className="text-[#8C8C8C] text-sm">
                  <span style={{ fontSize: "15px", fontWeight: 700 }}>
                    &#x9F3;
                  </span>
                  {subTotal > 0 ? subTotal.toFixed(2) : "0.00"}
                </p>
              </div>
            </div>
            <div className="grid grid-cols-12">
              <div className="col-span-9">
                <p className="text-[#8C8C8C] text-sm">Delivery fee</p>
              </div>
              <div className="col-span-3 text-right">
                <p className="text-[#8C8C8C] text-sm">
                  <span style={{ fontSize: "15px", fontWeight: 700 }}>
                    &#x9F3;
                  </span>
                  {vatTaxDelivery?.delivery_charge}
                </p>
              </div>
            </div>
            <div className="grid grid-cols-12">
              <div className="col-span-9">
                <p className="text-[#8C8C8C] text-sm">VAT</p>
              </div>
              <div className="col-span-3 text-right">
                <p className="text-[#8C8C8C] text-sm">{vatTaxDelivery?.vat}%</p>
              </div>
            </div>
            <div className="grid grid-cols-12">
              <div className="col-span-9">
                <p className="text-[#134E47] font-semibold text-sm">
                  Total(Incl. VAT)
                </p>
              </div>
              <div className="col-span-3 text-right">
                <p className="text-[#134E47] font-semibold text-sm">
                  <span style={{ fontSize: "15px", fontWeight: 700 }}>
                    &#x9F3;
                  </span>
                  {total > 0 ? total.toFixed(2) : "0.00"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          style={customStyles}
          contentLabel="our modal"
        >
          {prescriptionFile === "" && prescribed && (
            <div className="modal-header bg-white text-center  py-2 px-2">
              <h6 className="text-lg font-bold mb-1">
                <HiOutlineX
                  onClick={() => setIsOpen(false)}
                  className="inline float-right cursor-pointer"
                />
              </h6>
              <h6 className="text-lg text-red-500 font-bold my-3">
                Please upload your prescription !!
              </h6>
              <button
                onClick={() => setIsOpen(false)}
                className=" w-[50%] mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg"
              >
                CONTINUE
              </button>
            </div>
          )}

          {(prescriptionFile || !prescribed) && (
            <div className="modal-header bg-white text-center  py-2 px-2">
              <h6 className="text-lg font-bold mb-1">
                <HiOutlineX
                  onClick={() => setIsOpen(false)}
                  className="inline float-right cursor-pointer"
                />
              </h6>
              <h6 className="text-lg font-bold my-3">Thank You !!</h6>
              <div className="flex justify-center">
                <img className="h-[60px]" src={thanks} alt="" />
              </div>
              <h6 className="text-lg font-bold my-3">Order No.- 12307</h6>
              <p>Your order has been placed. </p>
              <Link
                to={`/medicine-list/<span style={{ fontSize: "15px", fontWeight: 700 }}>    &#x9F3;</span>{pharmacyData.id}`}
              >
                <button
                  onClick={() => {
                    setIsOpen(true);
                    setCart([]);
                  }}
                  className=" w-[50%] mt-3 py-1 bg-[#134E47] text-white font-medium rounded-lg"
                >
                  CONTINUE
                </button>
              </Link>
            </div>
          )}
        </Modal>
      </div>
      <div className="mx-2 sm:mx-6 md:mx-12 lg:mx-20 xl-mx-28">
        <Footer />
      </div>
    </div>
  );
};

export default Checkout;
